var React = require('react');

function Backward (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 96v320c0 27.39-31.9 41.79-52.51 24.59L288 297.69v-83.38L459.49 71.45C480.1 54.25 512 68.65 512 96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M11.48 231.41l192-160C224.1 54.25 256 68.65 256 96v320c0 27.39-31.9 41.79-52.51 24.59l-192-160a32.07 32.07 0 0 1-.01-49.18z","className":"fa-primary","key":2})]);
}

Backward.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Backward;

Backward.default = Backward;
